<template>
  <div class="row col-xl-12 col-lg-12 order-lg-2 order-xl-1">
    <div class="col-6" style="padding: 0;">
      <KTReportPortlet
        v-bind="{ bodyFit: true }"
        v-bind:class="'kt-portlet--height-fluid theme-seize-purple'"
      >
        <template v-slot:body>
          <div class="basic-table">
            <div class="basic-table__header">
              <div class="d-flex align-items-center flex-row">
                <div class="col-6">
                  <h3 class="basic-table__title__white">
                    특수/생활/기타 거래
                  </h3>
                </div>
                <div class="col-6 text-right">
                  <b-button
                    :pressed.sync="valueMode"
                    class="outline-seizepurple-reverse-button"
                    variant="outline-seizepurple"
                    v-on:click="initValueMode"
                    >금액
                  </b-button>
                  <b-button
                    :pressed.sync="countMode"
                    class="outline-seizepurple-reverse-button"
                    variant="outline-seizepurple"
                    v-on:click="initCountMode"
                    >건수
                  </b-button>
                </div>
              </div>
            </div>
            <div class="basic-table__table row">
              <div class="col-4">
                <canvas ref="equity-chart" height="200"></canvas>
              </div>
              <div class="col-4">
                <canvas ref="liability-chart" height="200"></canvas>
              </div>
              <div class="col-4">
                <canvas ref="etc-chart" height="200"></canvas>
              </div>
            </div>
          </div>
        </template>
      </KTReportPortlet>
    </div>
    <div class="col-6" style="padding: 0;">
      <KTPortlet
        v-bind="{ bodyFit: true }"
        v-bind:class="'kt-portlet--height-fluid'"
      >
        <template v-slot:body>
          <div class="row no-gutters">
            <div class="col-6" style="padding: 0;">
              <ReportOutputTable
                v-bind="{
                  titleColorClassString: 'text-seizepurple',
                  outputData: outputTableData,
                  isHaveLink: isHaveLink,
                  titleButtonLink: '#/inout_info/etc',
                  titleButtonVariant: 'outline-seizepurple',
                  titleButtonClass: 'seizepurple-button',
                }"
              >
              </ReportOutputTable>
            </div>
            <div class="col-6" style="padding: 0;">
              <ReportInputTable
                v-bind="{
                  titleColorClassString: 'text-seizepurple',
                  inputData: inputTableData,
                  isHaveLink: isHaveLink,
                  titleButtonLink: '#/inout_info/etc',
                  titleButtonVariant: 'outline-seizepurple',
                  titleButtonClass: 'seizepurple-button',
                }"
              >
              </ReportInputTable>
            </div>
          </div>
        </template>
      </KTPortlet>
    </div>
  </div>
</template>

<script>
import KTReportPortlet from "@/views/partials/content/ReportPortlet.vue";
import KTPortlet from "@/views/partials/content/Portlet.vue";

import ReportOutputTable from "@/views/partials/widgets/tables/ReportOutputTable";
import ReportInputTable from "@/views/partials/widgets/tables/ReportInputTable";
import * as d3 from "d3";
import numeral from "@/common/utils/numeral";
import SeizePlugin from "@/common/utils/seize";
import Vue from "vue";
import Chart from "chart.js";

Vue.use(SeizePlugin);
export default {
  name: "EtcReport",
  components: {
    KTReportPortlet,
    KTPortlet,
    ReportOutputTable,
    ReportInputTable,
  },
  data() {
    return {
      baseDate: this.$store.getters.baseDate,
      countMode: false,
      valueMode: true,
      inputTableData: [],
      outputTableData: [],
      chartCountMax: Number.MIN_SAFE_INTEGER,
      chartValueMax: Number.MIN_SAFE_INTEGER,
    };
  },
  props: {
    isHaveLink: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  mounted() {
    this.baseDate = Vue.initBaseDate(this.baseDate);
    this.initializeCategoryData();
    this.generateEquityData();
    this.generateLiabilityData();
    this.generateEtcData();
    this.initChart();
    this.generateTableData();
  },
  methods: {
    updateView() {
      this.baseDate = this.$store.getters.baseDate;
      this.initializeCategoryData();
      this.generateEquityData();
      this.generateLiabilityData();
      this.generateEtcData();
      if (this.countMode) {
        this.initCountMode();
      } else {
        this.initValueMode();
      }
      this.generateTableData();
    },
    initializeCategoryData() {
      this.categoryMap = d3
        .nest()
        .key(function (data) {
          return data.category_code1;
        })
        .map(this.$store.getters.requestItem.items);
    },
    initChart() {
      this.countMode = false;
      this.valueMode = true;
      this.equityChartData = {
        labels: this.makeChartLabel(),
        datasets: this.makeChartValueData(this.equityRawData),
      };
      this.equityChartOptions = {
        type: "bar",
        data: this.equityChartData,
        options: {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "특수활동",
            position: "bottom",
            fontColor: "#fff",
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                display: true,
                gridLines: {
                  color: "transparent",
                  lineWidth: 0,
                  zeroLineColor: "rgba(255,255,255,1)",
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  suggestedMax: this.chartValueMax,
                  callback: function (value) {
                    return numeral(value).format("0,0") + "원";
                  },
                },
              },
            ],
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  fontColor: "rgba(255,255,255,1)",
                },
              },
            ],
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItems, data) {
                const labelText =
                  data.datasets[tooltipItems.datasetIndex].label;
                const value =
                  data.datasets[tooltipItems.datasetIndex].data[
                    tooltipItems.index
                  ];
                return labelText + " : " + numeral(value).format("0,0") + "원";
              },
            },
          },
        },
      };
      this.equityChart = this.drawChart(
        "equity-chart",
        this.equityChartOptions
      );
      this.liabilityChartData = {
        labels: this.makeChartLabel(),
        datasets: this.makeChartValueData(this.liabilityRawData),
      };
      this.liabilityChartOptions = {
        type: "bar",
        data: this.liabilityChartData,
        options: {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "생활",
            position: "bottom",
            fontColor: "#fff",
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                display: true,
                gridLines: {
                  color: "transparent",
                  lineWidth: 0,
                  zeroLineColor: "rgba(255,255,255,1)",
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  suggestedMax: this.chartValueMax,
                  callback: function (value) {
                    return numeral(value).format("0,0") + "원";
                  },
                },
              },
            ],
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  fontColor: "rgba(255,255,255,1)",
                },
              },
            ],
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItems, data) {
                const labelText =
                  data.datasets[tooltipItems.datasetIndex].label;
                const value =
                  data.datasets[tooltipItems.datasetIndex].data[
                    tooltipItems.index
                  ];
                return labelText + " : " + numeral(value).format("0,0") + "원";
              },
            },
          },
        },
      };
      this.liabilityChart = this.drawChart(
        "liability-chart",
        this.liabilityChartOptions
      );
      this.etcChartData = {
        labels: this.makeChartLabel(),
        datasets: this.makeChartValueData(this.etcRawData),
      };
      this.etcChartOptions = {
        type: "bar",
        data: this.etcChartData,
        options: {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "기타/미분류",
            position: "bottom",
            fontColor: "#fff",
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                display: true,
                gridLines: {
                  color: "transparent",
                  lineWidth: 0,
                  zeroLineColor: "rgba(255,255,255,1)",
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  suggestedMax: this.chartValueMax,
                  callback: function (value) {
                    return numeral(value).format("0,0") + "원";
                  },
                },
              },
            ],
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  fontColor: "rgba(255,255,255,1)",
                },
              },
            ],
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItems, data) {
                const labelText =
                  data.datasets[tooltipItems.datasetIndex].label;
                const value =
                  data.datasets[tooltipItems.datasetIndex].data[
                    tooltipItems.index
                  ];
                return labelText + " : " + numeral(value).format("0,0") + "원";
              },
            },
          },
        },
      };
      this.etcChart = this.drawChart("etc-chart", this.etcChartOptions);
    },
    initCountMode() {
      this.countMode = true;
      this.valueMode = false;
      this.equityChartData.datasets = this.makeChartCountData(
        this.equityRawData
      );
      this.equityChartOptions.options.scales.yAxes = [
        {
          display: true,
          gridLines: {
            color: "transparent",
            lineWidth: 0,
            zeroLineColor: "rgba(255,255,255,1)",
          },
          ticks: {
            display: false,
            beginAtZero: true,
            suggestedMax: this.chartCountMax,
            callback: function (value) {
              return numeral(value).format("0,0") + "건";
            },
          },
        },
      ];
      this.equityChartOptions.options.tooltips.callbacks = {
        label: function (tooltipItems, data) {
          const labelText = data.datasets[tooltipItems.datasetIndex].label;
          const value =
            data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
          return labelText + " : " + numeral(value).format("0,0") + "건";
        },
      };
      this.equityChart.update();

      this.liabilityChartData.datasets = this.makeChartCountData(
        this.liabilityRawData
      );
      this.liabilityChartOptions.options.scales.yAxes = [
        {
          display: true,
          gridLines: {
            color: "transparent",
            lineWidth: 0,
            zeroLineColor: "rgba(255,255,255,1)",
          },
          ticks: {
            display: false,
            beginAtZero: true,
            suggestedMax: this.chartCountMax,
            callback: function (value) {
              return numeral(value).format("0,0") + "건";
            },
          },
        },
      ];
      this.liabilityChartOptions.options.tooltips.callbacks = {
        label: function (tooltipItems, data) {
          const labelText = data.datasets[tooltipItems.datasetIndex].label;
          const value =
            data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
          return labelText + " : " + numeral(value).format("0,0") + "건";
        },
      };
      this.liabilityChart.update();

      this.etcChartData.datasets = this.makeChartCountData(this.etcRawData);
      this.etcChartOptions.options.scales.yAxes = [
        {
          display: true,
          gridLines: {
            color: "transparent",
            lineWidth: 0,
            zeroLineColor: "rgba(255,255,255,1)",
          },
          ticks: {
            display: false,
            beginAtZero: true,
            suggestedMax: this.chartCountMax,
            callback: function (value) {
              return numeral(value).format("0,0") + "건";
            },
          },
        },
      ];
      this.etcChartOptions.options.tooltips.callbacks = {
        label: function (tooltipItems, data) {
          const labelText = data.datasets[tooltipItems.datasetIndex].label;
          const value =
            data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
          return labelText + " : " + numeral(value).format("0,0") + "건";
        },
      };
      this.etcChart.update();
    },
    initValueMode() {
      this.countMode = false;
      this.valueMode = true;
      this.equityChartData.datasets = this.makeChartValueData(
        this.equityRawData
      );
      this.equityChartOptions.options.scales.yAxes = [
        {
          display: true,
          gridLines: {
            color: "transparent",
            lineWidth: 0,
            zeroLineColor: "rgba(255,255,255,1)",
          },
          ticks: {
            display: false,
            beginAtZero: true,
            suggestedMax: this.chartValueMax,
            callback: function (value) {
              return numeral(value).format("0,0") + "원";
            },
          },
        },
      ];
      this.equityChartOptions.options.tooltips.callbacks = {
        label: function (tooltipItems, data) {
          const labelText = data.datasets[tooltipItems.datasetIndex].label;
          const value =
            data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
          return labelText + " : " + numeral(value).format("0,0") + "원";
        },
      };
      this.equityChart.update();

      this.liabilityChartData.datasets = this.makeChartValueData(
        this.liabilityRawData
      );
      this.liabilityChartOptions.options.scales.yAxes = [
        {
          display: true,
          gridLines: {
            color: "transparent",
            lineWidth: 0,
            zeroLineColor: "rgba(255,255,255,1)",
          },
          ticks: {
            display: false,
            beginAtZero: true,
            suggestedMax: this.chartValueMax,
            callback: function (value) {
              return numeral(value).format("0,0") + "원";
            },
          },
        },
      ];
      this.liabilityChartOptions.options.tooltips.callbacks = {
        label: function (tooltipItems, data) {
          const labelText = data.datasets[tooltipItems.datasetIndex].label;
          const value =
            data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
          return labelText + " : " + numeral(value).format("0,0") + "원";
        },
      };
      this.liabilityChart.update();

      this.etcChartData.datasets = this.makeChartValueData(this.etcRawData);
      this.etcChartOptions.options.scales.yAxes = [
        {
          display: true,
          gridLines: {
            color: "transparent",
            lineWidth: 0,
            zeroLineColor: "rgba(255,255,255,1)",
          },
          ticks: {
            display: false,
            beginAtZero: true,
            suggestedMax: this.chartValueMax,
            callback: function (value) {
              return numeral(value).format("0,0") + "원";
            },
          },
        },
      ];
      this.etcChartOptions.options.tooltips.callbacks = {
        label: function (tooltipItems, data) {
          const labelText = data.datasets[tooltipItems.datasetIndex].label;
          const value =
            data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
          return labelText + " : " + numeral(value).format("0,0") + "원";
        },
      };
      this.etcChart.update();
    },
    makeChartLabel() {
      const result = ["3M", "2M", "1M"];
      return result;
    },
    makeChartValueData(rawData) {
      const result = [];
      const netProfit = {
        label: "입금금액",
        backgroundColor: "rgba(255, 255, 255, 1)",
      };
      const revenue = {
        label: "출금금액",
        backgroundColor: "rgba(176, 137, 253, 1)",
      };
      const netProfitData = [];
      const revenueData = [];
      rawData.input.forEach((element) => {
        netProfitData.push(Math.round(element.sum));
      });
      rawData.output.forEach((element) => {
        revenueData.push(Math.round(element.sum));
      });

      netProfit.data = netProfitData.reverse();
      revenue.data = revenueData.reverse();
      result.push(revenue);
      result.push(netProfit);
      return result;
    },
    makeChartCountData(rawData) {
      const result = [];
      const netProfit = {
        label: "입금수",
        backgroundColor: "rgba(255, 255, 255, 1)",
      };
      const revenue = {
        label: "출금수",
        backgroundColor: "rgba(176, 137, 253, 1)",
      };
      const netProfitData = [];
      const revenueData = [];
      rawData.input.forEach((element) => {
        netProfitData.push(Math.round(element.count));
      });
      rawData.output.forEach((element) => {
        revenueData.push(Math.round(element.count));
      });

      netProfit.data = netProfitData.reverse();
      revenue.data = revenueData.reverse();
      result.push(revenue);
      result.push(netProfit);
      return result;
    },
    drawChart(refName, chartOptions) {
      const ctx = this.$refs[refName].getContext("2d");
      const gradient = ctx.createLinearGradient(0, 0, 0, 100);
      gradient.addColorStop(
        0,
        Chart.helpers.color("#e14c86").alpha(1).rgbString()
      );
      gradient.addColorStop(
        1,
        Chart.helpers.color("#e14c86").alpha(0.3).rgbString()
      );
      return new Chart(ctx, chartOptions);
    },
    generateEquityData() {
      let equityList = this.getEquityCategoryData(this.categoryMap);
      const monthBaseInputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(equityList);
      const monthBaseOutputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(equityList);
      this.equityRawData = this.getSimpleChartResult(
        monthBaseInputData,
        monthBaseOutputData
      );
    },
    generateLiabilityData() {
      let equityList = this.getLiabilityCategoryData(this.categoryMap);
      const monthBaseInputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(equityList);
      const monthBaseOutputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(equityList);
      this.liabilityRawData = this.getSimpleChartResult(
        monthBaseInputData,
        monthBaseOutputData
      );
    },
    generateEtcData() {
      let equityList = this.getEtcCategoryData(this.categoryMap);
      const monthBaseInputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(equityList);
      const monthBaseOutputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(equityList);
      this.etcRawData = this.getSimpleChartResult(
        monthBaseInputData,
        monthBaseOutputData
      );
    },
    generateTableData() {
      let salesList = this.getCategoryData(this.categoryMap);
      const monthBaseInputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === 1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(salesList);
      const monthBaseOutputData = d3
        .nest()
        .key(function (data) {
          return Vue.dateToDateString(data.tran_date);
        })
        .rollup(function (values) {
          return {
            count: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return 1;
              } else {
                return 0;
              }
            }),
            sum: d3.sum(values, function (data) {
              if (data.inout_code === -1) {
                return data.tran_amt;
              } else {
                return 0;
              }
            }),
          };
        })
        .entries(salesList);
      this.inputTableData = this.getSimpleResult(monthBaseInputData);
      this.outputTableData = this.getSimpleResult(monthBaseOutputData);
    },
    getCategoryData(categoryMap) {
      let result = [];
      const codeList = [
        "WDETSPM00130000",
        "DPETAUT00000000",
        "WDLFEDU00360000",
        "WDLFEDU01430000",
        "WDLFEDU01520000",
        "WDLFEDU01780000",
        "WDLFEDU02500000",
        "WDLFEDU02510000",
        "DPLFTRP00370000",
        "DPLFTRP00810027",
        "DPLFTRP00810077",
        "DPLFTRP02310000",
        "DPLFTRP02140000",
        "DPLFTRP02300000",
        "DPLFTRP02350000",
        "WDLFTRP00370000",
        "WDLFTRP00810027",
        "WDLFTRP00810077",
        "WDLFTRP02140000",
        "WDLFTRP02300000",
        "WDLFTRP02350000",
        "WDLFTRP00370067",
        "WDLFTRP00370141",
        "WDLFTRP00810028",
        "WDLFTRP00810029",
        "WDLFTRP00810030",
        "WDLFTRP00810035",
        "WDLFTRP00810051",
        "WDLFTRP00810053",
        "WDLFTRP00810069",
        "WDLFTRP00810076",
        "WDLFTRP00810078",
        "WDLFTRP00810124",
        "WDLFTRP00810125",
        "WDLFTRP00810141",
        "WDLFTRP00810000",
        "WDLFTRP02140010",
        "WDLFTRP02140011",
        "WDLFTRP02140021",
        "WDLFTRP02140022",
        "WDLFTRP02140026",
        "WDLFTRP02140036",
        "WDLFTRP02140116",
        "WDLFTRP02140117",
        "WDLFTRP02140118",
        "WDLFTRP02300055",
        "WDLFTRP02300141",
        "WDLFTRP02310000",
        "WDLFDON00000000",
        "WDLFLNS00030000",
        "WDLFLNS00280000",
        "WDLFLNS00300000",
        "WDLFLNS00520000",
        "WDLFLNS00570000",
        "WDLFLNS00780000",
        "WDLFLNS00920000",
        "WDLFLNS01200000",
        "WDLFLNS01220000",
        "WDLFLNS01310000",
        "WDLFLNS01340000",
        "WDLFLNS01360000",
        "WDLFLNS01510000",
        "WDLFLNS01580000",
        "WDLFLNS01630000",
        "WDLFLNS01810000",
        "WDLFLNS01920000",
        "WDLFLNS02280000",
        "WDLFLNS02320000",
        "WDLFLNS02490000",
        "WDLFLNS02630000",
        "WDLFLNS02680000",
        "WDLFMOB00000000",
        "WDLFCLT00310000",
        "WDLFCLT00760000",
        "WDLFCLT01070000",
        "WDLFCLT01480099",
        "WDLFCLT01480000",
        "WDLFCLT02370000",
        "WDLFDSV00000000",
        "DPLFLAW00000000",
        "WDLFLAW00000000",
        "WDLFSCR00000000",
        "WDLFBTY00500000",
        "WDLFBTY00630000",
        "WDLFBTY00960000",
        "WDLFBTY01540000",
        "WDLFBTY02450000",
        "WDLFBTY02620000",
        "WDLFBTY02670000",
        "WDLFEWF00000000",
        "WDLFSPA00000000",
        "WDLFPHO00000000",
        "WDLFLDY00000000",
        "WDLFSHP00050000",
        "WDLFSHP00060000",
        "WDLFSHP00070000",
        "WDLFSHP00090000",
        "WDLFSHP00110000",
        "WDLFSHP00160000",
        "WDLFSHP00290000",
        "WDLFSHP00450000",
        "WDLFSHP00480000",
        "WDLFSHP00600000",
        "WDLFSHP00650000",
        "WDLFSHP00700000",
        "WDLFSHP00730000",
        "WDLFSHP00750000",
        "WDLFSHP00800070",
        "WDLFSHP00800079",
        "WDLFSHP00800000",
        "WDLFSHP01020000",
        "WDLFSHP01130000",
        "WDLFSHP01160000",
        "WDLFSHP01170000",
        "WDLFSHP01210032",
        "WDLFSHP01210122",
        "WDLFSHP01210000",
        "WDLFSHP01240122",
        "WDLFSHP01240000",
        "WDLFSHP01330079",
        "WDLFSHP01330000",
        "WDLFSHP01370000",
        "WDLFSHP01380000",
        "WDLFSHP01440000",
        "WDLFSHP01530000",
        "WDLFSHP01720122",
        "WDLFSHP01720000",
        "WDLFSHP01770000",
        "WDLFSHP01820000",
        "WDLFSHP01940000",
        "WDLFSHP01970000",
        "WDLFSHP02130000",
        "WDLFSHP02220000",
        "WDLFSHP02270000",
        "WDLFSHP02290000",
        "WDLFSHP02390032",
        "WDLFSHP02390122",
        "WDLFSHP02390000",
        "WDLFSHP02420000",
        "WDLFSHP02600000",
        "WDLFSHP02660000",
        "WDLFSHP02690000",
        "WDLFMED00000000",
        "WDLFACM00680000",
        "WDLFACM00740000",
        "WDLFACM01190000",
        "WDLFACM02640000",
        "DPLFCAS00000000",
        "WDLFCAS00000000",
        "WDLFENT00020000",
        "WDLFENT00040000",
        "WDLFENT00200000",
        "WDLFENT01400000",
        "WDLFENT01640000",
        "WDLFENT01700000",
        "WDLFTRA00320000",
        "WDLFTRA00420000",
        "WDLFTRA00710000",
        "WDLFTRA01450000",
        "WDLFTRA02580074",
        "WDLFTRA02580000",
        "WDLFRTR00380000",
        "WDLFRTR00460000",
        "WDLFRTR00470000",
        "WDLFRTR00660000",
        "WDLFRTR00790000",
        "WDLFRTR00940000",
        "WDLFRTR00950000",
        "WDLFRTR01040000",
        "WDLFRTR01750000",
        "WDLFRTR02040000",
        "WDLFRTR02080000",
        "WDLFRTR02210000",
        "WDLFRTR02380000",
        "WDLFRTR02400000",
        "WDLFRTR02440000",
        "WDLFRTR02480000",
        "WDLFRTR02560000",
        "WDLFRTR02650000",
        "WDLFRTR02700000",
        "WDLFHYG00000000",
        "WDLFKID00000000",
        "WDLFMCT00120000",
        "WDLFMCT00150000",
        "WDLFMCT00490000",
        "WDLFMCT00620000",
        "WDLFMCT00690000",
        "WDLFMCT00840000",
        "WDLFMCT00980000",
        "WDLFMCT01080000",
        "WDLFMCT01150000",
        "WDLFMCT01230000",
        "WDLFMCT01390000",
        "WDLFMCT01410000",
        "WDLFMCT01470000",
        "WDLFMCT01550000",
        "WDLFMCT01600000",
        "WDLFMCT01730000",
        "WDLFMCT01830000",
        "WDLFMCT01890000",
        "WDLFMCT01900000",
        "WDLFMCT01980000",
        "WDLFMCT01990000",
        "WDLFMCT02200000",
        "WDLFMCT02460000",
        "WDLFMCT02470000",
        "WDLFMCT02550000",
        "WDLFMCT02570000",
        "WDLFMCT02710000",
        "WDLFCAR01610000",
        "WDLFCAR00580000",
        "WDLFCAR00670000",
        "WDLFCAR01110000",
        "WDLFCAR01620000",
        "WDLFCAR01790000",
        "WDLFCAR01960102",
        "WDLFCAR01960103",
        "WDLFCAR01960104",
        "WDLFCAR02030006",
        "WDLFCAR02030008",
        "WDLFCAR02030017",
        "WDLFCAR02030019",
        "WDLFCAR02030044",
        "WDLFCAR02030083",
        "WDLFCAR02030137",
        "WDLFCAR02030000",
        "WDLFCAR02050000",
        "WDLFCAR02180003",
        "WDLFCAR02180007",
        "WDLFCAR02180009",
        "WDLFCAR02180018",
        "WDLFCAR02180020",
        "WDLFCAR02180084",
        "WDLFCAR02180108",
        "WDLFCAR02180138",
        "WDLFCAR02180000",
        "WDLFCAR02240000",
        "WDETECO01930000",
        "WDLFGSV00000000",
        "WDFICAD02410000",
        "WDLFCNB00830000",
        "WDLFCNB01350000",
        "WDLFCNB01690000",
        "WDLFCNB02260000",
        "WDLFCPR00000000",
        "WDLFCLD00000000",
        "DPLFSAC00100000",
        "DPLFSAC00210000",
        "DPLFSAC00220000",
        "DPLFSAC00230000",
        "DPLFSAC00550000",
        "DPLFSAC00910000",
        "DPLFSAC02250000",
        "DPLFSAC02330000",
        "WDLFSAC00100000",
        "WDLFSAC00210000",
        "WDLFSAC00220000",
        "WDLFSAC00230000",
        "WDLFSAC00240000",
        "WDLFSAC00550000",
        "WDLFSAC00910000",
        "WDLFSAC01140000",
        "WDLFSAC02250000",
        "WDLFSAC02330000",
        "DPNAZZZ00000000",
        "IDNAZZZ00000000",
        "IFNAZZZ00000000",
        "WDNAZZZ00000000",
        "CCNAZZZ00000000",
      ];

      codeList.forEach((element) => {
        if (categoryMap.get(element))
          result = result.concat(categoryMap.get(element));
      });
      return result;
    },
    getEquityCategoryData(categoryMap) {
      let result = [];
      const codeList = [
        "DPLFSAC00100000",
        "DPLFSAC00210000",
        "DPLFSAC00220000",
        "DPLFSAC00230000",
        "DPLFSAC00550000",
        "DPLFSAC00910000",
        "DPLFSAC02250000",
        "DPLFSAC02330000",
        "WDLFSAC00100000",
        "WDLFSAC00210000",
        "WDLFSAC00220000",
        "WDLFSAC00230000",
        "WDLFSAC00240000",
        "WDLFSAC00550000",
        "WDLFSAC00910000",
        "WDLFSAC01140000",
        "WDLFSAC02250000",
        "WDLFSAC02330000",
      ];

      codeList.forEach((element) => {
        if (categoryMap.get(element))
          result = result.concat(categoryMap.get(element));
      });
      return result;
    },
    getLiabilityCategoryData(categoryMap) {
      let result = [];
      const codeList = [
        "WDLFEDU00360000",
        "WDLFEDU01430000",
        "WDLFEDU01520000",
        "WDLFEDU01780000",
        "WDLFEDU02500000",
        "WDLFEDU02510000",
        "DPLFTRP00370000",
        "DPLFTRP00810027",
        "DPLFTRP00810077",
        "DPLFTRP02310000",
        "DPLFTRP02140000",
        "DPLFTRP02300000",
        "DPLFTRP02350000",
        "WDLFTRP00370000",
        "WDLFTRP00810027",
        "WDLFTRP00810077",
        "WDLFTRP02140000",
        "WDLFTRP02300000",
        "WDLFTRP02350000",
        "WDLFTRP00370067",
        "WDLFTRP00370141",
        "WDLFTRP00810028",
        "WDLFTRP00810029",
        "WDLFTRP00810030",
        "WDLFTRP00810035",
        "WDLFTRP00810051",
        "WDLFTRP00810053",
        "WDLFTRP00810069",
        "WDLFTRP00810076",
        "WDLFTRP00810078",
        "WDLFTRP00810124",
        "WDLFTRP00810125",
        "WDLFTRP00810141",
        "WDLFTRP00810000",
        "WDLFTRP02140010",
        "WDLFTRP02140011",
        "WDLFTRP02140021",
        "WDLFTRP02140022",
        "WDLFTRP02140026",
        "WDLFTRP02140036",
        "WDLFTRP02140116",
        "WDLFTRP02140117",
        "WDLFTRP02140118",
        "WDLFTRP02300055",
        "WDLFTRP02300141",
        "WDLFTRP02310000",
        "WDLFDON00000000",
        "WDLFLNS00030000",
        "WDLFLNS00280000",
        "WDLFLNS00300000",
        "WDLFLNS00520000",
        "WDLFLNS00570000",
        "WDLFLNS00780000",
        "WDLFLNS00920000",
        "WDLFLNS01200000",
        "WDLFLNS01220000",
        "WDLFLNS01310000",
        "WDLFLNS01340000",
        "WDLFLNS01360000",
        "WDLFLNS01510000",
        "WDLFLNS01580000",
        "WDLFLNS01630000",
        "WDLFLNS01810000",
        "WDLFLNS01920000",
        "WDLFLNS02280000",
        "WDLFLNS02320000",
        "WDLFLNS02490000",
        "WDLFLNS02630000",
        "WDLFLNS02680000",
        "WDLFMOB00000000",
        "WDLFCLT00310000",
        "WDLFCLT00760000",
        "WDLFCLT01070000",
        "WDLFCLT01480099",
        "WDLFCLT01480000",
        "WDLFCLT02370000",
        "WDLFDSV00000000",
        "DPLFLAW00000000",
        "WDLFLAW00000000",
        "WDLFSCR00000000",
        "WDLFBTY00500000",
        "WDLFBTY00630000",
        "WDLFBTY00960000",
        "WDLFBTY01540000",
        "WDLFBTY02450000",
        "WDLFBTY02620000",
        "WDLFBTY02670000",
        "WDLFEWF00000000",
        "WDLFSPA00000000",
        "WDLFPHO00000000",
        "WDLFLDY00000000",
        "WDLFSHP00050000",
        "WDLFSHP00060000",
        "WDLFSHP00070000",
        "WDLFSHP00090000",
        "WDLFSHP00110000",
        "WDLFSHP00160000",
        "WDLFSHP00290000",
        "WDLFSHP00450000",
        "WDLFSHP00480000",
        "WDLFSHP00600000",
        "WDLFSHP00650000",
        "WDLFSHP00700000",
        "WDLFSHP00730000",
        "WDLFSHP00750000",
        "WDLFSHP00800070",
        "WDLFSHP00800079",
        "WDLFSHP00800000",
        "WDLFSHP01020000",
        "WDLFSHP01130000",
        "WDLFSHP01160000",
        "WDLFSHP01170000",
        "WDLFSHP01210032",
        "WDLFSHP01210122",
        "WDLFSHP01210000",
        "WDLFSHP01240122",
        "WDLFSHP01240000",
        "WDLFSHP01330079",
        "WDLFSHP01330000",
        "WDLFSHP01370000",
        "WDLFSHP01380000",
        "WDLFSHP01440000",
        "WDLFSHP01530000",
        "WDLFSHP01720122",
        "WDLFSHP01720000",
        "WDLFSHP01770000",
        "WDLFSHP01820000",
        "WDLFSHP01940000",
        "WDLFSHP01970000",
        "WDLFSHP02130000",
        "WDLFSHP02220000",
        "WDLFSHP02270000",
        "WDLFSHP02290000",
        "WDLFSHP02390032",
        "WDLFSHP02390122",
        "WDLFSHP02390000",
        "WDLFSHP02420000",
        "WDLFSHP02600000",
        "WDLFSHP02660000",
        "WDLFSHP02690000",
        "WDLFMED00000000",
        "WDLFACM00680000",
        "WDLFACM00740000",
        "WDLFACM01190000",
        "WDLFACM02640000",
        "DPLFCAS00000000",
        "WDLFCAS00000000",
        "WDLFENT00020000",
        "WDLFENT00040000",
        "WDLFENT00200000",
        "WDLFENT01400000",
        "WDLFENT01640000",
        "WDLFENT01700000",
        "WDLFTRA00320000",
        "WDLFTRA00420000",
        "WDLFTRA00710000",
        "WDLFTRA01450000",
        "WDLFTRA02580074",
        "WDLFTRA02580000",
        "WDLFRTR00380000",
        "WDLFRTR00460000",
        "WDLFRTR00470000",
        "WDLFRTR00660000",
        "WDLFRTR00790000",
        "WDLFRTR00940000",
        "WDLFRTR00950000",
        "WDLFRTR01040000",
        "WDLFRTR01750000",
        "WDLFRTR02040000",
        "WDLFRTR02080000",
        "WDLFRTR02210000",
        "WDLFRTR02380000",
        "WDLFRTR02400000",
        "WDLFRTR02440000",
        "WDLFRTR02480000",
        "WDLFRTR02560000",
        "WDLFRTR02650000",
        "WDLFRTR02700000",
        "WDLFHYG00000000",
        "WDLFKID00000000",
        "WDLFMCT00120000",
        "WDLFMCT00150000",
        "WDLFMCT00490000",
        "WDLFMCT00620000",
        "WDLFMCT00690000",
        "WDLFMCT00840000",
        "WDLFMCT00980000",
        "WDLFMCT01080000",
        "WDLFMCT01150000",
        "WDLFMCT01230000",
        "WDLFMCT01390000",
        "WDLFMCT01410000",
        "WDLFMCT01470000",
        "WDLFMCT01550000",
        "WDLFMCT01600000",
        "WDLFMCT01730000",
        "WDLFMCT01830000",
        "WDLFMCT01890000",
        "WDLFMCT01900000",
        "WDLFMCT01980000",
        "WDLFMCT01990000",
        "WDLFMCT02200000",
        "WDLFMCT02460000",
        "WDLFMCT02470000",
        "WDLFMCT02550000",
        "WDLFMCT02570000",
        "WDLFMCT02710000",
        "WDLFCAR01610000",
        "WDLFCAR00580000",
        "WDLFCAR00670000",
        "WDLFCAR01110000",
        "WDLFCAR01620000",
        "WDLFCAR01790000",
        "WDLFCAR01960102",
        "WDLFCAR01960103",
        "WDLFCAR01960104",
        "WDLFCAR02030006",
        "WDLFCAR02030008",
        "WDLFCAR02030017",
        "WDLFCAR02030019",
        "WDLFCAR02030044",
        "WDLFCAR02030083",
        "WDLFCAR02030137",
        "WDLFCAR02030000",
        "WDLFCAR02050000",
        "WDLFCAR02180003",
        "WDLFCAR02180007",
        "WDLFCAR02180009",
        "WDLFCAR02180018",
        "WDLFCAR02180020",
        "WDLFCAR02180084",
        "WDLFCAR02180108",
        "WDLFCAR02180138",
        "WDLFCAR02180000",
        "WDLFCAR02240000",
        "WDETECO01930000",
        "WDLFGSV00000000",
        "WDFICAD02410000",
        "WDLFCNB00830000",
        "WDLFCNB01350000",
        "WDLFCNB01690000",
        "WDLFCNB02260000",
        "WDLFCPR00000000",
        "WDLFCLD00000000",
      ];

      codeList.forEach((element) => {
        if (categoryMap.get(element))
          result = result.concat(categoryMap.get(element));
      });
      return result;
    },
    getEtcCategoryData(categoryMap) {
      let result = [];
      const codeList = [
        "WDETSPM00130000",
        "DPETAUT00000000",
        "DPNAZZZ00000000",
        "IDNAZZZ00000000",
        "IFNAZZZ00000000",
        "WDNAZZZ00000000",
        "CCNAZZZ00000000",
      ];
      codeList.forEach((element) => {
        if (categoryMap.get(element))
          result = result.concat(categoryMap.get(element));
      });
      return result;
    },
    getSimpleResult(values) {
      const result = [];
      const baseDate = this.baseDate;
      const before1M = Vue.getBeforeMonthString(baseDate, 1);
      const before2M = Vue.getBeforeMonthString(baseDate, 2);
      const before3M = Vue.getBeforeMonthString(baseDate, 3);
      let before1M_count = 0,
        before1M_value = 0,
        before2M_count = 0,
        before2M_value = 0,
        before3M_count = 0,
        before3M_value = 0;
      values.forEach((element) => {
        if (element.key <= baseDate && element.key > before1M) {
          before1M_count += element.value.count;
          before1M_value += element.value.sum;
        }
        if (element.key <= before1M && element.key > before2M) {
          before2M_count += element.value.count;
          before2M_value += element.value.sum;
        }
        if (element.key <= before2M && element.key > before3M) {
          before3M_count += element.value.count;
          before3M_value += element.value.sum;
        }
      });
      const b1MData = {
        key: "1M",
        count: numeral(before1M_count).format("0,0") + "건",
        sum: numeral(before1M_value).format("0,0") + "원",
      };
      const b2MData = {
        key: "2M",
        count: numeral(before2M_count).format("0,0") + "건",
        sum: numeral(before2M_value).format("0,0") + "원",
      };
      const b3MData = {
        key: "3M",
        count: numeral(before3M_count).format("0,0") + "건",
        sum: numeral(before3M_value).format("0,0") + "원",
      };
      const sumData = {
        key: "합계",
        count:
          numeral(before1M_count + before2M_count + before3M_count).format(
            "0,0"
          ) + "건",
        sum:
          numeral(before1M_value + before2M_value + before3M_value).format(
            "0,0"
          ) + "원",
      };
      const avgData = {
        key: "평균",
        count:
          numeral(
            Math.round((before1M_count + before2M_count + before3M_count) / 3)
          ).format("0,0") + "건",
        sum:
          before1M_count + before2M_count + before3M_count === 0
            ? "0원"
            : numeral(
                Math.round(
                  (before1M_value + before2M_value + before3M_value) /
                    (before1M_count + before2M_count + before3M_count)
                )
              ).format("0,0") + "원",
      };
      result.push(b1MData);
      result.push(b2MData);
      result.push(b3MData);
      result.push(sumData);
      result.push(avgData);
      return result;
    },
    getSimpleChartResult(inputValues, outputValues) {
      const inputResult = [];
      const outputResult = [];
      const baseDate = this.baseDate;
      const before1M = Vue.getBeforeMonthString(baseDate, 1);
      const before2M = Vue.getBeforeMonthString(baseDate, 2);
      const before3M = Vue.getBeforeMonthString(baseDate, 3);
      let before1M_count = 0,
        before1M_value = 0,
        before2M_count = 0,
        before2M_value = 0,
        before3M_count = 0,
        before3M_value = 0;
      inputValues.forEach((element) => {
        if (this.chartValueMax < element.value.sum) {
          this.chartValueMax = element.value.sum;
        }
        if (this.chartCountMax < element.value.count) {
          this.chartCountMax = element.value.count;
        }
        if (element.key <= baseDate && element.key > before1M) {
          before1M_count += element.value.count;
          before1M_value += element.value.sum;
        }
        if (element.key <= before1M && element.key > before2M) {
          before2M_count += element.value.count;
          before2M_value += element.value.sum;
        }
        if (element.key <= before2M && element.key > before3M) {
          before3M_count += element.value.count;
          before3M_value += element.value.sum;
        }
      });
      let b1MData = {
        key: "1M",
        count: before1M_count,
        sum: before1M_value,
      };
      let b2MData = {
        key: "2M",
        count: before2M_count,
        sum: before2M_value,
      };
      let b3MData = {
        key: "3M",
        count: before3M_count,
        sum: before3M_value,
      };
      inputResult.push(b1MData);
      inputResult.push(b2MData);
      inputResult.push(b3MData);

      before1M_count = 0;
      before1M_value = 0;
      before2M_count = 0;
      before2M_value = 0;
      before3M_count = 0;
      before3M_value = 0;
      outputValues.forEach((element) => {
        if (this.chartValueMax < element.value.sum) {
          this.chartValueMax = element.value.sum;
        }
        if (this.chartCountMax < element.value.count) {
          this.chartCountMax = element.value.count;
        }
        if (element.key <= baseDate && element.key > before1M) {
          before1M_count += element.value.count;
          before1M_value += element.value.sum;
        }
        if (element.key <= before1M && element.key > before2M) {
          before2M_count += element.value.count;
          before2M_value += element.value.sum;
        }
        if (element.key <= before2M && element.key > before3M) {
          before3M_count += element.value.count;
          before3M_value += element.value.sum;
        }
      });
      b1MData = {
        key: "1M",
        count: before1M_count,
        sum: before1M_value,
      };
      b2MData = {
        key: "2M",
        count: before2M_count,
        sum: before2M_value,
      };
      b3MData = {
        key: "3M",
        count: before3M_count,
        sum: before3M_value,
      };
      outputResult.push(b1MData);
      outputResult.push(b2MData);
      outputResult.push(b3MData);
      return { input: inputResult, output: outputResult };
    },
  },
};
</script>

<style scoped></style>
